import { useMemo, useState } from "react";
import { VaultFolderList } from "apps/project-iq/components/VaultFolderList/VaultFolderList";
import { VaultMeetingsDialog } from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog";
import { createVaultMeetingFixtures } from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog.constants";
import { VaultWorkflowCards } from "apps/project-iq/components/VaultWorkflowCards/VaultWorkflowCards";
import { WorkspaceInfoBanner } from "apps/project-iq/components/WorkspaceInfoBanner/WorkspaceInfoBanner";
import {
  VAULT_FALLBACK_NAME,
  VAULT_FIXTURE_NODES,
  VAULT_MEETINGS_CARD_ID,
  VAULT_WORKFLOW_CARDS,
} from "./VaultPage.constants";
import { useVaultPageStyles } from "./VaultPage.styles";
import { IVaultPageProps } from "./VaultPage.types";

const VAULT_BANNER_TEXT =
  "The Vault is this engagement's AI-ready knowledge layer. Meetings, transcripts, chats, emails and documents saved here are stored in SharePoint and available as context throughout Project IQ.";

export const VaultPage = ({
  workspaceCode,
  clientName,
}: IVaultPageProps = {}): JSX.Element => {
  const styles = useVaultPageStyles();
  const vaultName = workspaceCode || clientName || VAULT_FALLBACK_NAME;
  const [meetingsOpenedAt, setMeetingsOpenedAt] = useState<Date | null>(null);
  const meetings = useMemo(
    () =>
      meetingsOpenedAt ? createVaultMeetingFixtures(meetingsOpenedAt) : [],
    [meetingsOpenedAt],
  );

  // TODO: the other workflow cards have no behavior yet.
  const handleOpenCard = (cardId: string): void => {
    if (cardId === VAULT_MEETINGS_CARD_ID) setMeetingsOpenedAt(new Date());
  };

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.contentInner}>
          <VaultWorkflowCards
            cards={VAULT_WORKFLOW_CARDS}
            onOpenCard={handleOpenCard}
          />
          <VaultFolderList vaultName={vaultName} nodes={VAULT_FIXTURE_NODES} />
          <WorkspaceInfoBanner>{VAULT_BANNER_TEXT}</WorkspaceInfoBanner>
        </div>
      </div>
      {meetingsOpenedAt && (
        <VaultMeetingsDialog
          meetings={meetings}
          today={meetingsOpenedAt}
          onClose={() => setMeetingsOpenedAt(null)}
        />
      )}
    </div>
  );
};
